import { Component, Input, OnInit } from '@angular/core';
import { WebsiteService } from '../../../../services/website.service';

@Component({
	selector: 'app-components-specialist-boost-site-accounts-read-only',
	templateUrl: './boost-site-accounts-read-only.component.html'
})
export class BoostSiteAccountsReadOnlyComponent implements OnInit {
  @Input() public customerId: number;

  websites: Boo.Objects.Websites.Website[];

  constructor(
    private websiteService: WebsiteService,
  ) { }

  ngOnInit(): void {
    this.websiteService.getManyByCustomerId(this.customerId)
      .subscribe(websites => this.websites = websites);
  }
}
